"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonPageALMeta = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const head_1 = require("../head");
/**
 * @description config related to appLink & universalLink on facebook
 */
class CommonPageALMeta extends react_1.Component {
    constructor() {
        super(...arguments);
        this.appStoreIdStr = '1498607143';
    }
    render() {
        return ((0, jsx_runtime_1.jsxs)(head_1.DynamicHead, { children: [(0, jsx_runtime_1.jsx)("meta", { property: "al:ios:url", content: this.props.openUrl }), (0, jsx_runtime_1.jsx)("meta", { property: "al:ios:app_store_id", content: this.appStoreIdStr }), (0, jsx_runtime_1.jsx)("meta", { property: "al:ios:app_name", content: "Lemon8" }), (0, jsx_runtime_1.jsx)("meta", { property: "al:android:url", content: this.props.openUrl }), (0, jsx_runtime_1.jsx)("meta", { property: "al:android:app_name", content: "Lemon8" }), (0, jsx_runtime_1.jsx)("meta", { property: "al:android:package", content: "com.bd.nproject" }), (0, jsx_runtime_1.jsx)("meta", { property: "al:web:url", content: this.props.webUrl })] }));
    }
}
exports.CommonPageALMeta = CommonPageALMeta;
